import React from 'react';

import { Board, ExportBlock } from '@/Components/Partials';
import { Button, Icon } from '@/Components/UI';
import { Tools } from '@/Services';

import { DeviceProps } from './DeviceProps';
import S from './styles.module.scss';
import { useDeviceCard } from './useDeviceCard';

export const DeviceCard: React.FC<DeviceProps> = ({ device, onClickEditLicenseKey, isDisableAllActions }) => {
    const { isLoading, modal, showChambers } = useDeviceCard();

    return (
        <Board.Item className={S.device_card}>
            <h2>{device.type?.name}</h2>
            <div>
                <h3>Device ID</h3>
                <p>{device.id}</p>
            </div>
            <div>
                <h3>UDI</h3>
                <p>{device.identifier}</p>
            </div>
            <div>
                <h3>Current WLM firmware version</h3>
                {device.wlm_firmware_version && (
                    <p>
                        {device.wlm_firmware_version.name}
                        {device.wlm_firmware_version.is_outdated ? <Icon name="warning" size={15} /> : <Icon name="green-checkmark" size={15} />}
                    </p>
                )}
            </div>

            <div>
                <h3>Current LMP firmware version</h3>
                {device.lmp_firmware_version && (
                    <p>
                        {device.lmp_firmware_version.name}
                        {device.lmp_firmware_version.is_outdated ? <Icon name="warning" size={15} /> : <Icon name="green-checkmark" size={15} />}
                    </p>
                )}
            </div>
            <div>
                <h3>MAC address</h3>
                <p>{device.mac_address}</p>
            </div>
            <div>
                <h3>M-Sector UDI</h3>
                <p>{device.m_sector_udi}</p>
            </div>
            <div>
                <h3>LMP HW version</h3>
                <p>{device.lmp_hardware_version}</p>
            </div>
            <div>
                <h3>Battery Status</h3>
                <p>{device.battery && `${device.battery}%`}</p>
            </div>
            <div>
                <h3>Last update</h3>
                <p>{device.updated_at && Tools.date.autoFormat(device.updated_at * 1000)}</p>
            </div>
            <div>
                <h3>License key</h3>
                {device.license_key ? <p className={S.license_key}>{device.license_key}</p> : <p className={S.license_key_error}>Not specified</p>}
            </div>
            <div>
                <h3>License key status</h3>
                {device.license_key_status ? (
                    <p className={S.license_key}>{device.license_key_status}</p>
                ) : (
                    <p className={S.license_key_error}>Not specified</p>
                )}
            </div>

            <Button disabled={isDisableAllActions} color="transparent" className={S.license_key__edit_button} onClick={() => onClickEditLicenseKey(device)}>
                Edit license key
            </Button>

            <Button disabled={isLoading || !device.has_chambers || isDisableAllActions} color="brown" onClick={() => showChambers(device.id)}>
                Chambers
            </Button>

            <ExportBlock className={S.device_card__export} model="device_chambers" filters={{ device_id: device.id }} />

            {modal}
        </Board.Item>
    );
};
